<template>
  <div class="index">
    <div class="pro">
      <h1 class="text-center" style="margin-bottom:5px">精选产品</h1>
      <h4 class="text-center font-weight-normal" style="margin-top:0px">Handpicked Items</h4>
      <div class="pro">
        <!-- flex-align flex-center  -->
        <div v-for="(item,index) in proList" :key="index" class="i-block pro-div" @click="caseDetail(item.id,item.is_login,item.is_vip,item.type)">
          <img :src="item.imgs" alt="" class="pro-img">
          <div style="padding:10px 10px">
            <div>{{item.title}}</div>
            <div class="flex-align flex-center">
              <div>
                <b style="font-size:14px;color:#FF7A5E">套餐价：{{item.price}}</b>
                <div style="font-size:12px;color:#8a8a8a">{{item.org_name}}</div>
              </div>
              <div>
                <el-button type="warning" round size="small">立即购买</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-title font-s24 c33">健康资讯</div>
    <div class="articl-list clearfix">
      <div class="fl list-l">
        <img src="../../../src/assets/image/articl.png">
      </div>
      <div class="fr list-r">
        <div class="list clearfix  font-s14 pd-t-20" v-for="(item,index) in list" :key="index" @click="articleDetails(item.newid)">
          <div class="fl"><span class="c66">{{item.title}}</span></div>
          <div class="fr c66">{{item.addtime}}</div>
        </div>
      </div>
    </div>
    <div class="link-list">
      <div class="list clearfix">
        <div class="fl" v-for="(item,index) in link" :key="index">
          <router-link :to='item.link'>
            <img :src="item.url">
            <div class="text-center font-s18 c33 pd-t-20">{{item.name}}</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NewsList, HealthySchemeItemList } from '../../api/api'
export default {
  data() {
    return {
      link: [
        {
          url: require('@/assets/image/healthCare.png'),
          link: '/healthCare/caseList',
          name: '医疗方案',
        },
        {
          url: require('@/assets/image/serve.png'),
          link: '/service/service',
          name: '专业服务',
        },
        {
          url: require('@/assets/image/charge.png'),
          link: '/charge/charge',
          name: '收费标准',
        },
        {
          url: require('@/assets/image/about.png'),
          link: '/about/about',
          name: '关于我们',
        },
      ],
      list: [],
      proList: [],
    }
  },
  created() {
    this.$axios.post(NewsList, {}).then(
      (res) => {
        if (res.data.code == 1) {
          this.list = res.data.data
        } else {
          this.list = []
        }
      },
      (err) => {
        this.list = []
      }
    )
    this.getPro()
  },
  methods: {
    getPro() {
      this.$axios.post(HealthySchemeItemList, {}).then(
        (res) => {
          if (res.data.code == 1) {
            this.proList = res.data.data
          } else {
            this.proList = []
          }
        },
        (err) => {
          this.proList = []
        }
      )
    },
    articleDetails(newid) {
      this.$router.push({
        name: 'indexArticleDetails',
        query: { newid: newid },
      })
    },
    caseDetail(id, login, vip, type) {
      //答题
      var item = {
        id: id,
        type: type, //类型    1量表 2新闻   3商品
      }
      if (type != 3) {
        this.$router.push({
          name: 'healthCareDetailResult',
          query: { item: JSON.stringify(item) },
        })
      } else {
        this.$router.push({
          name: 'healthCareTreatmentPlan',
          query: { item: JSON.stringify(item) },
        })
      }
    },
  },
}
</script>

<style lang="scss">
.index {
  .link-list {
    padding-top: 100px;
    .list > div {
      margin-right: 20px;
    }
    .list > div:last-child {
      margin-right: 0px;
    }
  }
  .pro {
    width: 1020px;
    margin-bottom: 30px;
    .pro-img {
      width: 320px;
      height: 199px;
    }
    .pro-div {
      border: 1px solid #e5e5e5;
      margin-top: 10px;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }
  .pro-div:nth-child(2),
  .pro-div:nth-child(5) {
    margin: 2px 26px;
  }
}
</style>
